import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import { Link } from '@Hotels-at-Home/hah-fe-core/dist/components';

const BeddingSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$beddingSection' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$beddingSection' });

  return (
    <section id="hp-bedding" className="hp-section bedding-section bedding">
      <div
        className="hp-banner desktop-only"
        data-event-name="bloc_interact"
        data-bloc-name={t('title')}
      >
        <Link href={tLink('bed')} className="clearfix">
          <div className="ctg-image">
            <picture>
              <source
                data-srcset="/images/homepage/beddingSection/LEM-Bedding-mob.jpg"
                media="(max-width: 768px)"
                srcSet="/images/homepage/beddingSection/LEM-Bedding-mob.jpg"
              />
              <img
                data-src="/images/homepage/beddingSection/LEM-Bedding.jpg"
                alt={t('alt')}
                src="/images/homepage/beddingSection/LEM-Bedding.jpg"
                loading="lazy"
                decoding="async"
                fetchPriority="low"
                width="960"
                height="700"
              />
            </picture>
          </div>
          <div className="stack right lem-bar">
            <h2>
              {t('title')}
              <span>{t('titleSpan')}</span>
            </h2>
            <p className="desktop-only">{t('copy')}</p>
            <span className="btn base-btn btn-main">
              <span>{tButton('shopNow')}</span>
            </span>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default BeddingSection;
